import Link from "next/link";
import getGoogleMapsSearchUrl from "../util/getGoogleMapsSearchUrl";
import clsMerge from "../util/clsMerge";

interface AddressLinkProps {
	address: string;
	noLinkStyling?: boolean;
}

const AddressLink = ({address, noLinkStyling = false}: AddressLinkProps) => {
	return (
		<Link
			className={clsMerge(noLinkStyling ? "underline" : "text-hyperlink")}
			href={getGoogleMapsSearchUrl(address)}
			target="_blank"
		>
			<p className="whitespace-pre-line">{address}</p>
		</Link>
	);
};

export default AddressLink;
